// @ts-nocheck
import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { compose } from '@/utils';
import { Icon, FormattedMessage as T } from '@/components';
import withDialogActions from '@/containers/Dialog/withDialogActions';

function SalesPeopleActions({ openDialog }) {
  const handleClickNewCurrency = useCallback(() => {
    openDialog('sales-people-form' );

  }, [openDialog]);

  return (
    <div class="users-actions">
      <Button
        icon={<Icon icon="plus" iconSize={12} />}
        onClick={handleClickNewCurrency}
        intent={Intent.PRIMARY}
        style={{ backgroundColor: '#2196F3' }}
      >
        <T id={'new_Salesperson'} />
      </Button>
    </div>
  );
}

export default compose(withDialogActions)(SalesPeopleActions);
